/* @flow */
import { alertCreationLocalStorageName } from 'src/utils/config';

export default {
  methods: {
    saveAlertDataToLocalStorage(alertData: iAlertForm, tickerId: number = this.tickerId) {
      const data = this.getAlertsDataFromLocalStorage();
      data[tickerId] = alertData;
      localStorage.setItem(alertCreationLocalStorageName, JSON.stringify(data));
    },
    getAlertsDataFromLocalStorage(): iAlertForm[] {
      return JSON.parse(localStorage.getItem(alertCreationLocalStorageName)) || {}; // eslint-disable-line
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/saveAlertDataToLocalStorage.js